import { RouteComponentProps } from "react-router";
import { Plan } from "../../@types";

export enum ToggledFrom {
  "toggledFromList",
  "toggledFromTray",
}

export interface InNetworkSelectPharmaciesPlanParams {
  id: string;
}

export interface SelectPharmaciesPageProps extends RouteComponentProps {
  isInNetwork?: boolean;
}

export enum PlanDetailsStatus {
  None,
  // loading plan data
  Loading,
  // successfully loaded plan data
  Success,
  // failed to load plan data
  Error,
}
export interface PlanDetailsState {
  status: PlanDetailsStatus;
  plan: Plan | undefined;
  error?: Error;
}
